export default "__VITE_ASSET__be0e9dff__"